var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"k-chip-input"},[_c('span',{staticClass:"k-chip-input-value"},[_vm._v(_vm._s(_vm.output))]),_c('span',{staticClass:"k-chip-input-remove",on:{"click":_vm.removeChipItem}},[_c('base-times-icon',{staticClass:"base-times-icon",attrs:{"length":12,"fill":"#fff"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }